<template>
  <DataGridPaginationSimple
    v-if="mode === 'simple'"
    :current-page="currentPage"
    :total-pages="totalPages"
    :total-items="totalItems"
    :per-page="perPage"
    @page-change="emit('page-change', $event)"
  />
  <DataGridPaginationFull
    v-else
    :current-page="currentPage"
    :total-pages="totalPages"
    :total-items="totalItems"
    :per-page="perPage"
    @page-change="emit('page-change', $event)"
  />
</template>

<script setup lang="ts">
import DataGridPaginationSimple from './DataGridPaginationSimple.vue';
import DataGridPaginationFull from './DataGridPaginationFull.vue';

interface Props {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  perPage: number;
  mode?: 'simple' | 'full';
}


interface Emits {
  (e: 'page-change', page: number): void;
}

const props = withDefaults(defineProps<Props>(), {
  mode: 'full',
});
const emit = defineEmits<Emits>();
</script>

